import React from "react";
import style from "./index.module.scss";
const Summary = ({ summary }) => {
  return (
    <div className={style.summary}>
      <table>
        <tr className={style.summaryTh}>
          <td>Tổng số Meet toàn hệ thống</td>
          <td>Số User mới tham gia</td>
          <td>User Diamond</td>
          <td>User Ruby</td>
          <td>User Sapphire</td>
        </tr>
        <tr className={style.summaryTd}>
          <td>{summary?.total_system_meet_count}</td>
          <td>{summary?.user_count}</td>
          <td>{summary?.diamond_user_count}</td>
          <td>{summary?.ruby_user_count}</td>
          <td>{summary?.sapphire_user_count}</td>
        </tr>
      </table>
    </div>
  );
};

export default Summary;
